import Core from '../Core'

export default class BatchUploaderBatifid {
  constructor (uuid) {
    this._uuid = uuid
  }

  add ({ file, onProgress }) {
    return Core.execute('Api', 'uploadFile', { file, capturedAt: new Date(), onProgress })
  }
}
